import { IconDefinition } from "./types";

const buildingCircleCheck: IconDefinition = {
  iconName: "building-circle-check",
  width: 576,
  height: 512,
  svgPathData:
    "M80 48l288 0 0 170.9c15.2-5.4 31.3-8.9 48-10.3L416 0 32 0 32 512 276 512c-22.7-31.5-36-70.2-36-112 0-16.6 2.1-32.7 6-48l-70 0 0 112-96 0 0-416zM320 224l-64 0 0 64 20 0c12.2-16.9 27-31.8 44-44l0-20zM128 96l0 64 64 0 0-64-64 0zm192 0l-64 0 0 64 64 0 0-64zM128 224l0 64 64 0 0-64-64 0zM576 400a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-73.6-51.5l-9.4 12.9-64 88-11 15.1c-4.4-4.4-22.1-22.1-53.2-53.2L353.4 400 376 377.4c5 5 17.7 17.7 38.1 38.1l53-72.9 9.4-12.9 25.9 18.8z",
  iconType: "fill",
  fill: "none",
  fontAwesomeName: "building-circle-check",
  unicode: 0xe4d2,
};

export { buildingCircleCheck };
